<template>
    <div class="c-latest-articles">
        <div
            v-if="!hiddenTitle"
            class="c-latest-articles__title"
        >
            <h4>
                {{ $t('home.articles.title') }}
            </h4>
        </div>
        <div
            v-if="articles && articles.length"
            class="c-latest-articles__content"
        >
            <div class="blog-list">
                <y-slideshow
                    ref="Slideshow"
                    height="auto"
                    :other-options="options"
                    pagination="1"
                >
                    <y-slide
                        v-for="(post, index) in articles"
                        :key="`responsive-benefits-${index}`"
                    >
                        <router-link
                            :to="{
                                name: 'blog-single',
                                params: {slug: post.slug}}"
                        >
                            <y-blog-card
                                :post-data="post"
                                class="blog-item"
                            />
                        </router-link>
                    </y-slide>
                </y-slideshow>
            </div>

            <y-col
                class="c-latest-articles__content__show-more"
                size="12"
            >
                <y-button
                    color="white"
                    tag="router-link"
                    :to="{name: 'blog'}"
                >
                    {{ $t('home.articles.see_blog') }}
                </y-button>
            </y-col>
        </div>
    </div>
</template>

<script>

    import { date } from '@groot-nodes/helpers/date';
    import { digits } from '@groot-nodes/helpers/number';
    import YBlogCard from '@modules/blog/components/Categories/BlogCard/BlogCard.vue';
    import { YSlide, YSlideshow } from '@groot-components/all';

    export default {
        name      : 'LatestArticles',
        components: {
            YSlideshow,
            YSlide,
            YBlogCard,
        },

        props: {
            articles  : Array,
            hasH6Title: {
                type   : Boolean,
                default: false,
            },
            hiddenTitle: {
                type   : Boolean,
                default: false,
            },

        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                options: {
                    breakpoints: {
                        1400: {
                            slidesPerView: 3,
                            spaceBetween : 30,
                            pagination   : 0,
                        },

                        1200: {
                            slidesPerView: 3,
                            spaceBetween : 30,
                            pagination   : 0,
                        },

                        992: {
                            slidesPerView: 2.4,
                            spaceBetween : 30,
                            pagination   : 1,
                        },

                        768: {
                            slidesPerView: 2,
                            spaceBetween : 15,
                        },

                        480: {
                            slidesPerView: 1.3,
                            spaceBetween : 15,
                        },

                        375: {
                            slidesPerView: 1.1,
                            spaceBetween : 15,
                        },

                        0: {
                            slidesPerView: 1,
                            spaceBetween : 15,
                        },
                    },
                },
            };
        },

        methods: {
            digits,
            /**
             * generate new customized date from timestamp
             *
             * @param {*} timestamp
             * @returns {string}
             */
            convertTimestampToDate(timestamp) {
                const localDate = date(timestamp, 'MMMM DD,YYYY',
                                       this.$i18n.locale === 'ar' ? this.$i18n.locale === 'ar' : 'en');
                return `${localDate}`;
            },
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
